import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import Footer from "../../components/layout/Footer.tsx";

export default function Marketing() {
  const theme = useTheme();
  return (
    <Box
      className="login-marketing-wrapper"
      sx={{ bgcolor: theme.palette.primary.main }}
    >
      <Box className="login-marketing">
        <img src={"/logomark-tagline-dark.svg"} alt={"3Aware icon"} />
        <Typography
          align={"left"}
          variant={"h3"}
          sx={{ color: "common.white" }}
        >
          Data access, now.
        </Typography>
        <Typography
          align={"left"}
          variant={"h6"}
          sx={{ color: "common.white" }}
        >
          Enabling MedTech’s PMS teams with real-world data to accelerate PMCF
          reporting.
        </Typography>
      </Box>
      <Footer publicFooter={true} />
    </Box>
  );
}
